import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';
import { StartThemeInterface } from '../../domain/interface/start_theme_interface';
import { FinishThemeInterface } from '../../domain/interface/finish_theme_interface';

export class UserThemeApiService {
  private readonly userThemeBaseUrl: string;

  constructor() {
    this.userThemeBaseUrl = ApiConstants().userTheme;
  }

  async startTheme(data: StartThemeInterface): Promise<AxiosResponse> {
    const response = await request({
      url: `${this.userThemeBaseUrl}start`,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
      requiresToken: true,
    });
    return response;
  }

  async finishTheme(data: FinishThemeInterface): Promise<AxiosResponse> {
    const response = await request({
      url: `${this.userThemeBaseUrl}finish`,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
      requiresToken: true,
    });
    return response;
  }

  async deleteUserThemeInProgress(): Promise<AxiosResponse> {
    const response = await request({
      url: `${this.userThemeBaseUrl}give-up`,
      method: 'DELETE',
      requiresToken: true,
    });
    return response;
  }
}
